import { render, staticRenderFns } from "./CompanyHoursData.vue?vue&type=template&id=70876390"
import script from "./CompanyHoursData.vue?vue&type=script&lang=js"
export * from "./CompanyHoursData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports